import { render, staticRenderFns } from "./TciRecruitCard.vue?vue&type=template&id=ecd9b938"
import script from "./TciRecruitCard.vue?vue&type=script&lang=js"
export * from "./TciRecruitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports